import { Alert, AlertTitle, Box, Button, CircularProgress } from "@mui/material";
import { FC } from "react";

type FormSaveAndResetButtonsProps = {
  success: boolean;
  isSubmitDisabled: boolean;
  resetFormState?: () => void;
  isResetFormStateDisabled?: boolean;
  loading: boolean;
  title?: string;
  loadingTitle?: string;
}

const FormSaveAndResetButtons: FC<FormSaveAndResetButtonsProps> = ({
  success,
  isSubmitDisabled,
  resetFormState = () => {},
  isResetFormStateDisabled = false,
  loading = false,
  title = "Salvar",
  loadingTitle: loadingTile = "Enviando..."
}): JSX.Element => {
  return success ? (
    <>
      <Alert severity="success">
        <AlertTitle>
          Cadastrado finalizado com sucesso!
        </AlertTitle>
      </Alert>

      {!isResetFormStateDisabled && (
        <Button
          type="button"
          variant="contained"
          onClick={() => {
            resetFormState();
          }}
        >
          Limpar campos e começar novo cadastro
        </Button>
      )}
    </>
  ) : (
    <Button
      disabled={isSubmitDisabled || loading}
      type="submit"
      variant="contained"
    >
      {loading ? (
        <Box sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}>
          <CircularProgress
            size="1.25rem"
            sx={{
              marginRight: 1
            }}
          /> {loadingTile}
        </Box>
      ) : (
        <Box>{title}</Box>
      )}
    </Button>
  )
}

export default FormSaveAndResetButtons;
